export default {
    module: {
      name: 'hehongyuanlove-auth-qq',
      id: 'QQ',
      icon: 'fab fa-qq'
    },
    package: {
      name: 'hehongyuanlove-auth-qq'
    },
    api: {
      uri: '/api/auth/qq'
    }
  };
  